import React, { useState } from "react";
import { EditableTextField } from "../../../../Global_Component/CustomInputComponent";
import { CustomFileUpload } from "../../../../Global_Component/customFileUplodComponent";
import {
  Box,
  TextField,
  Button,
  Grid,
  Typography,
  InputLabel,
} from "@mui/material";
import {
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../Global_Component/GlobalButtonComponent";
import ClientSerivces from "../../Services/clientService";
const DirectorDetailsForm = ({ MoveToNextTab, MoveToPreviousTab }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  const handleInputChange = (e) => {
    const { files, name, value, type } = e.target;
    if (type == "file") {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handlleSubmit = async () => {
    console.log("come to submit the data")
    const payLoad = new FormData();
    Object.keys(formData).map((key) => {
      payLoad.append(key, formData[key]);
    });

    try {
      setLoading(true);
      const response = await ClientSerivces.createDirector(payLoad);
      if (response.success) {
        setLoading(false);
        MoveToNextTab();
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: "100%",
        margin: "auto",
        padding: "10px",

        borderRadius: "8px",
        backgroundColor: "#fff",
        height: "100%",
        overflowY: "auto",
      }}
    >
      <Typography
        variant="h6"
        sx={{ marginBottom: "20px", fontWeight: "bold", color: "#333" }}
      >
        Directors details
      </Typography>

      <Grid container sm={12} md={12} lg={8} xl={9} spacing={0}>
        <Grid item md={6} sx={{ p: 1, m: 0 }}>
          <EditableTextField
            label={"First Name"}
            name={"firstName"}
            value={formData.firstName}
            onChange={handleInputChange}
            isEdit={true}
          />
        </Grid>
        <Grid item md={6} sx={{ p: 1, m: 0 }}>
          <EditableTextField
           label={"Last Name"}
           name={"lastName"}
           value={formData.lastName}
           onChange={handleInputChange}
           isEdit={true}
          />
        </Grid>

        <Grid item md={6} sx={{ p: 1, m: 0 }}>
          <EditableTextField
           label={"Position"}
           name={"position"}
           value={formData.position}
           onChange={handleInputChange}
           isEdit={true}
          />
        </Grid>

        <Grid item md={6} sx={{ p: 1, m: 0 }}>
          <EditableTextField
           label={"Email"}
           name={"email"}
           value={formData.email}
           onChange={handleInputChange}
           isEdit={true}
          />
        </Grid>

        <Grid item md={6} sx={{ p: 1, m: 0 }}>
          <EditableTextField
            label={"Phone Number"}
            name={"phoneNumber"}
            value={formData.phoneNumber}
            onChange={handleInputChange}
            type="number"
            isEdit={true}
          />
        </Grid>
        <Grid item md={6} sx={{ p: 1, m: 0 }}>
          <EditableTextField
             label={"PAN Number"}
             name={"panNumber"}
             value={formData.panNumber}
             onChange={handleInputChange}
             isEdit={true}
          />
        </Grid>

        <Grid item md={6} sx={{ p: 1, m: 0 }}>
          <CustomFileUpload
            fileType={"image"}
            name={"panCard"}
            onChange={handleInputChange}
            label="Direcotr PAN Card"
          />
        </Grid>

        <Grid item md={6} sx={{ p: 1, m: 0 }}>
          <CustomFileUpload
            fileType={"image"}
            name={"idProof"}
            onChange={handleInputChange}
            label="Director ID Proof"
          />
        </Grid>

        <Grid item md={6} sx={{ p: 1, m: 0 }}>
          <CustomFileUpload
            fileType={"image"}
            name={"sign"}
            onChange={handleInputChange}
            label="Director Signature (for Seal)"
          />
        </Grid>
      </Grid>

      <Grid
        xs={12}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1,
        }}
      >
        <CustomSecondaryButton
          label={"Back"}
          sx={{ margin: 2 }}
          onClick={(e) => MoveToPreviousTab()}
        />
        <CustomSuccessButton loading={loading} label={"Save"} onClick={handlleSubmit} />
      </Grid>
    </Box>
  );
};

export default DirectorDetailsForm;
